import actionTypes from 'SRC/modules/redux/actionTypes'

export const setRegistrationFormulas = formulas => {
  return {
    type: actionTypes.SET_REGISTRATION_FORMULAS,
    payload: formulas
  }
}
